<template>
  <div id="tu">
    <div id="lond"></div>
  </div>
</template>

<script>
import * as echarts from "echarts";

export default {
  name: "tu",
  props:['sex'],
  data() {
    return {
      list_data:[],
    };
  },

 mounted() {
     this.daxian();
  setInterval(()=>{
      this.daxian();
  },1000);
  
  },

  methods: {
    daxian() {
      
        let list=this.sex
        function convertToArray(objct) {
          return Object.keys(objct).map((key) => ({
            name: key,
            value: list[key],
          }));
        }
        this.list_data = convertToArray(list);
        var option = {
          tooltip: {
            trigger: "item",
          },
          legend: {
            top: "5%",
            left: "left",
            orient: "vertical",
            x: "left",
            icon: "circle",
            data: ["男", "女"],
            textStyle: {
              //图例文字的样式
              color: "#fff",
              fontSize: 16,
            },
          },
          
          grid: {
            left: "5%", //距离左边距
          },
          series: [
            {
              name: "",
              type: "pie",
              radius: ["40%", "70%"],
              avoidLabelOverlap: false,
                   label: {
            show: true,
            position: 'outside',
            formatter: '{b|{b}}\n{a|{d}%}\n{hr|}',
            rich: {
                hr: {
                    backgroundColor: 't',
                    width: 3,
                    height: 3,
                    borderRadius: 3,
                    padding: [3,3,0,-12]
                },
                a: {
                    align: 'center',
                    padding: [-20,10,0,10],
                    height: 20
                },
                b: {
                    padding: [-20,10,-30,10]
                }
            }
        },
              emphasis: {
                label: {
                  show: true,
                  fontSize: "40",
                  fontWeight: "bold",
                },
              },
              labelLine: {
                show: true,
              },
              data:this.list_data
            },
          ],
        };
        //初始化echarts实例
        var myChart = echarts.init(document.getElementById("lond"));
        //使用制定的配置项和数据显示图表
        myChart.setOption(option);
        window.onresize = function() {
          myChart.resize();
        };
    },
  },
};
</script>

<style lang="scss" scoped>
#lond {
  width: 35vw;
  height: 22vh;
}

</style>
